import React  from 'react';
import {Row, Column, Container} from './layoutComponents';
import {Paper, H5, H4, H2, HeaderContainer, HeroHeaderImg, HeaderOverlay, HeaderText, SideNav, NavOverlay, QuoteBlock, Quote, Quotation} from './styledComponents';

export const Info = props =>{
  return(
    <Container>
      <HeaderContainer>
        <HeroHeaderImg background="https://firebasestorage.googleapis.com/v0/b/leafletv2.appspot.com/o/theme-assets%2Fleaflet_landing-04.png?alt=media&token=3c2bf1ce-5050-4ef5-bd45-a8950c3d1e30" >
        <HeaderText>Want to try out Leaflet - coding for the problem solvers?</HeaderText>
         </HeroHeaderImg>
       </HeaderContainer>

        <Column colWidth="70%" space="20px;">
        <H2>Some Things You Should Know...</H2>
        <Paper paperPadding="35px" paperMargin="0">
          <H4>So what is myJoe?</H4>
          <p>This nifty little coffee consumption tracker is a product of <a href="http://www.leafletlearning.com/" target="_blank">Leaflet Learning Real World React Course</a>. Since this product is still in active development, we thought we'd keep you posted on features and functionality that is in progress in case you come across something strange.</p>
        </Paper>
          <Paper paperPadding="35px" paperMargin="0">
            <H4>Why can't I reset my coffee count?</H4>
            <p>Because coffee is for life. Okay, maybe not. The real reason is just for testing. For the first little while we want to track usage. After about a month or so of trial, you'll be able to reset your coffee count whenever you please.</p>
          </Paper>
          <Paper paperPadding="35px" paperMargin="0">
            <H4>Why can't I add my own credit card?</H4>
            <p>We don't actually want your money. KIDDING! Definitely kidding. Our credit card processing is still in development. Once it is completely setup for use, we welcome you to donate and help support further development of this product.</p>
          </Paper>
        </Column>

      <QuoteBlock><Quote><Quotation className="icon-quote-left"></Quotation>Keep calm and console log.</Quote></QuoteBlock>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/info.js